const getAllSeries = state => state?.series?.allSeries;
const getSeriesStatus = state => state?.series?.status;
const getSingleSeries = state => state?.series?.singleSeries;
const getSeriesErrors = state => state?.series?.error?.errors;
const getSeriesOptions = state => state?.series?.seriesOptions;
const getAllSeriesQueryParams = state => state?.series?.queryParams;

export { getAllSeries, getSeriesStatus, getSingleSeries, getSeriesErrors, getSeriesOptions, getAllSeriesQueryParams };
